import React from "react";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useCollection } from "react-firebase-hooks/firestore";
import { snapshotToArray } from "utils/react-lib/generic-ui/firebaseUtils";
import { collection } from "firebase/firestore";
import { db } from "firebaseApp";
import { useTheme } from "@emotion/react";

const AudioTextFileList = ({ onSelectFile }) => {

  const theme = useTheme();

  const [audioFilesSnap, loading, error] = useCollection(
    collection(db, "audioTextFiles")
  );

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return (
      <Typography color="error">
        Error loading audio files: {error.message}
      </Typography>
    );
  }

  const audioFiles = snapshotToArray(audioFilesSnap);

  if (audioFiles.length === 0) {
    return <Typography>No audio files available</Typography>;
  }

  return (
    <List>
      {audioFiles.map((file) => (
        <ListItem key={file.id} disablePadding>
          <ListItemButton onClick={() => onSelectFile(file.id)}>
            <ListItemText
              sx={{
                color: theme.palette.text.primary
              }}
              primary={file.fileName}
              secondary={`${file.totalPages} pages`}
            />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default AudioTextFileList;
